"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/prefer-stateless-function */
// TODO make SystemLockscreen a pure function
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var antd_1 = require("antd");
require("antd/lib/result/style");
var SystemLockscreen = /** @class */ (function (_super) {
    __extends(SystemLockscreen, _super);
    function SystemLockscreen() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemLockscreen.prototype.render = function () {
        return (react_1.default.createElement(antd_1.Result, { status: "403", title: "403", subTitle: "Sorry, you are not authorized to access this page." },
            react_1.default.createElement(react_helmet_1.Helmet, { title: "Lockscreen" })));
    };
    return SystemLockscreen;
}(react_1.default.Component));
exports.default = {
    name: 'Lockscreen',
    routeProps: {
        path: '/locked',
        component: SystemLockscreen,
    },
};
//# sourceMappingURL=index.js.map